import React from "react"
import { Button, Modal } from "react-bootstrap"
import { toAbsoluteUrl } from "../../../_metronic/_helpers"
import SVG from "react-inlinesvg"
import { ILLUSTRATION_CONSTANTS } from "../../../constants/ImageConstants"
import { POP_UP_TYPE_STRING } from "../../../constants/StringConstant.js"
import clsx from "clsx"

export const Popup = ({
  show = false,
  title,
  titleCustom,
  size,
  body,
  onCancel,
  contentClassName,
  showButton = true,
  bodyCustom,
  type,
  closeButton = false,
  centered = true,
  textButton = "Ok",
  onClick = () => {},
  isLoading = false,
  bodyCustomClassName = "",
  buttonRight = false,
  staticBackdrop = false
}) => {
  return (
    <Modal
      show={show}
      contentClassName={contentClassName}
      centered={centered}
      onHide={onCancel}
      size={size}
      backdrop={staticBackdrop ? "static" : true}
      keyboard={!staticBackdrop}>
      {(title || titleCustom) && (
        <Modal.Header closeButton={closeButton}>
          {title ? <h6 className="mb-0">{title}</h6> : titleCustom}
        </Modal.Header>
      )}
      {type && (
        <div className="mb-1 mt-3 text-center">
          {type === POP_UP_TYPE_STRING.EMPTY ? (
            <SVG src={toAbsoluteUrl(ILLUSTRATION_CONSTANTS.EMPTY)} />
          ) : (
            ""
          )}
          {type === POP_UP_TYPE_STRING.BERHASIL ? (
            <SVG src={toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS)} />
          ) : (
            ""
          )}
          {type === POP_UP_TYPE_STRING.GAGAL ? (
            <SVG src={toAbsoluteUrl(ILLUSTRATION_CONSTANTS.FAIL)} />
          ) : (
            ""
          )}
          {type === POP_UP_TYPE_STRING.NONIMAGE && ""}
        </div>
      )}

      {(body || bodyCustom) && (
        <Modal.Body className={bodyCustomClassName}>
          {body ? <div className="text-center">{body}</div> : bodyCustom}
        </Modal.Body>
      )}
      {showButton && (
        <div
          className={clsx([
            "d-flex",
            buttonRight ? "justify-content-end" : "justify-content-center",
            "my-6",
            "mx-6"
          ])}>
          <Button
            className={clsx(["font-weight-bold"])}
            disabled={isLoading}
            variant="primary"
            block={!buttonRight}
            onClick={onClick}>
            {textButton}
          </Button>
        </div>
      )}
    </Modal>
  )
}
